<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Báo cáo</div>
      </div>
      <div class="card card-w-title">
        <div class="class-parent" v-if="$myConstants.checkRoleGroup('report_warranty_activation', 'list')"><!--v-if="$myConstants.checkRoleGroup('report_warranty_activation', 'list')"-->
          <div class="class-boder" v-on:click="OnClicked('warranty_activation')">
            <div class="class-custom">
              <img style="width: 50px;height: 50px;" :src="icon_x1">
              <span class="class-span">Báo cáo kích hoạt bảo hành sản phẩm</span>
              <img style="float: right;width: 50px;height: 50px;" :src="icon_x2">
            </div>
          </div>
        </div>
        <div class="class-parent" v-if="$myConstants.checkRoleGroup('report_appraisal_product', 'list')"><!--v-if="$myConstants.checkRoleGroup('report_appraisal_product', 'list')"-->
          <div class="class-boder" v-on:click="OnClicked('change_return_appraisal')">
            <div class="class-custom">
              <img style="width: 50px;height: 50px;" :src="icon_x1">
              <span class="class-span">Báo cáo đổi - trả - thẩm định sản phẩm</span>
              <img style="float: right;width: 50px;height: 50px;" :src="icon_x2">
            </div>
          </div>
        </div>
        <div class="class-parent" v-if="$myConstants.checkRoleGroup('report_repair_warranty_maintenance', 'list')"><!--v-if="$myConstants.checkRoleGroup('report_repair_warranty_maintenance', 'list')"-->
          <div class="class-boder" v-on:click="OnClicked('repair_warranty_maintenance')">
            <div class="class-custom">
              <img style="width: 50px;height: 50px;" :src="icon_x1">
              <span class="class-span">Báo cáo sửa chữa - bảo hành - bảo trì sản phẩm</span>
              <img style="float: right;width: 50px;height: 50px;" :src="icon_x2">
            </div>
          </div>
        </div>
        <div class="class-parent"  v-if="$myConstants.checkRoleGroup('report_service_supplies', 'list')"><!--v-if="$myConstants.checkRoleGroup('report_service_supplies', 'list')"-->
          <div class="class-boder" v-on:click="OnClicked('materials_services')">
            <div class="class-custom">
              <img style="width: 50px;height: 50px;" :src="icon_x1">
              <span class="class-span">Báo cáo vật tư - dịch vụ đã sử dụng</span>
              <img style="float: right;width: 50px;height: 50px;" :src="icon_x2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DataServices from '@/core/DataServices'

export default {
  components: {

  },
  data() {
    return {
      icon_x1 : "../../../assets/images/icon_x1.png",
      icon_x2 : "../../../assets/images/icon_x2.png",
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.$myConstants.checkRoleGroup('report', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {

    },
    async OnClicked(key=''){
      if(key == 'warranty_activation'){
        this.$router.push({path: '/admin/report-warranty-activation'});
      }else if(key == 'change_return_appraisal'){
        this.$router.push({path: '/admin/report-appraisal-product'});
      }else if(key == 'repair_warranty_maintenance'){
        this.$router.push({path: '/admin/report-warranty-repair'});
      }else if(key == 'materials_services'){
        this.$router.push({path: '/admin/report-service-supplies'});
      }
    }
  }
}

</script>
<!-- <script type="text/javascript">
  $(document).ready(function(){
  $('#rp_1').mouseover(function(){
    $('#rp_1').removeClass().addClass('topNavActive'),
  })
})
</script> -->
<style lang="scss">
.class-boder {
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(153, 153, 153, 1);
  border-radius: 10px;
  height: 80px;
  padding: 0px 30px 0px 30px;
  cursor: pointer;
}
.class-custom{
  padding: 14px 0 0 0;
}
.class-parent{
  padding: 30px 0 0 0;
}
.class-span{
  margin: 0px 0px 0px 40px;
  font-size: 20px;
}
</style>